import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _callSuper from "@babel/runtime/helpers/esm/callSuper";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import PropTypes from 'prop-types';
var WithArtifact = function WithArtifact(ComponentClass) {
  var _Class;
  return _Class = /*#__PURE__*/function (_React$Component) {
    function _Class() {
      _classCallCheck(this, _Class);
      return _callSuper(this, _Class, arguments);
    }
    _inherits(_Class, _React$Component);
    return _createClass(_Class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.loadIfNeeded(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.artifactId !== this.props.artifactId || prevProps.artifactType !== this.props.artifactType) {
          this.loadIfNeeded(this.props);
        }
      }
    }, {
      key: "loadIfNeeded",
      value: function loadIfNeeded(props) {
        var artifactId = props.artifactId,
          artifactType = props.artifactType,
          loadArtifact = props.loadArtifact;
        if (!this.state || this.state.artifactId !== artifactId && this.state.artifactType !== artifactType) {
          this.setState({
            artifactId: artifactId,
            artifactType: artifactType
          });
          loadArtifact({
            artifactId: artifactId,
            artifactType: artifactType
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(ComponentClass, this.props);
      }
    }]);
    _Class.displayName = "_Class";
  }(React.Component), _Class.propTypes = _objectSpread({
    loadArtifact: PropTypes.func.isRequired,
    artifactId: PropTypes.string,
    artifactType: PropTypes.string
  }, ComponentClass.propTypes), _Class.defaultProps = {
    artifactId: '',
    artifactType: ''
  }, _Class.displayName = "WithArtifact(".concat(ComponentClass.displayName, ")"), _Class;
};
export default WithArtifact;